import {isNil} from 'ramda';
import {isNotNil} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

const NON_BREAKING_SPACE_REGEX = /\u00a0/g;

/**
 * A rich-text editor always emits wrapper markup (e.g. `<p><br></p>`) even when it looks empty, so a
 * plain emptiness check treats a cleared editor as filled — a required-field rule written against a
 * textarea stops blocking anything the moment that field becomes rich text.
 *
 * A value counts as non-empty when it holds visible text or an embedded image, because a signature
 * that is only a logo and a body that is only a picture are both legitimate.
 */
export function isEmailHtmlEmpty(value: string | Nullish) {
  if (isNil(value)) {
    return true;
  }

  const parsedDocument = new DOMParser().parseFromString(value, 'text/html');

  if (isNotNil(parsedDocument.body.querySelector('img'))) {
    return false;
  }

  const textContent = (parsedDocument.body.textContent ?? '').replace(
    NON_BREAKING_SPACE_REGEX,
    ' '
  );

  return textContent.trim().length === 0;
}
